import { render, staticRenderFns } from "./TheStarIcon.vue?vue&type=template&id=7ec41240&"
import script from "./TheStarIcon.vue?vue&type=script&lang=js&"
export * from "./TheStarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports